import { View } from 'foundations-components/transitional/components/View';
import FeatureTableBadge from 'pricing-pages-ui-components/badges/FeatureTableBadge';
import { useAppSelector } from '../../../reducers';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export const RecommendedBadge = () => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  return /*#__PURE__*/_jsx(View, {
    position: "absolute",
    insetBlockStart: "200",
    insetInlineEnd: "200",
    children: /*#__PURE__*/_jsx(FeatureTableBadge, {
      translationKey: isAppAuth ? 'recommended' : 'mostPopular'
    })
  });
};